import {
  Component,
  Input,
  ViewEncapsulation,
  OnInit,
  Output,
  EventEmitter,
  Inject,
  Injector,
  OnChanges,
  SimpleChanges
} from '@angular/core';

import {RouteEventPoint} from "@commons/models/domain/RouteEventPoint";
import {RouteService} from '@commons/services/route/route.service';
import {RouteDrawerService} from '@commons/services/map/drawer/route/route-drawer.service';
import {RouteEvent} from '@commons/models/domain/RouteEvent';

import {TranslateService} from "@ngx-translate/core";
import { DistancePipe } from '../../../../../../commons/pipes/distance.pipe';

@Component({
  selector: 'tk-vehicle-details-route-item',
  styleUrls: ['./vehicle-details-route-item.component.less'],
  templateUrl: './vehicle-details-route-item.component.html',
  encapsulation: ViewEncapsulation.None
})
export class VehicleDetailsRouteItemComponent implements OnInit, OnChanges {

  @Input()
  public route?: RouteEvent;

  @Input() points?: RouteEventPoint[];

  @Output()
  public onRouteEventDetailUpdate: EventEmitter<RouteEvent> = new EventEmitter<RouteEvent>();

  public StartDateTime?: Date;

  public EndDateTime?: Date;

  public Description?: string;

  public Duration?: number;

  public Description2: any;

  drivingDescriptionTranslation = '';

  public readonly currentDateISO = new Date().toISOString();

  public ngOnInit(): void {

    this.StartDateTime = this.route?.St;
    this.EndDateTime = this.route?.En;

    this.calculateDetails(this.route!);

    switch (this.route?.T) {
      case 0:
        const p = new DistancePipe(this.$injector);
        this.Description = p.transform(this.route.D.D);
        break;
      // jedzie
      case 3:
        this.Description = this.drivingDescriptionTranslation;
        this.Description2 = this.route.D.S;
        break;
      // stoi
      case 1:
        this.Description2 = this.route.D.E || this.route.D.S;
        this.Description = this.Description2 ? `${this.Description2.St}` : '';
        break;
      default:
        break;
    }
  }

  constructor(
    private $routeService: RouteService,
    private $routeDrawer: RouteDrawerService,
    private $injector: Injector,
    private translateService: TranslateService
  ) {
    this.translateService.get('vehicle-details-routes-tab.driving').subscribe(t => this.drivingDescriptionTranslation = t);
  }

  ngOnChanges(changes: SimpleChanges): void {
    //punkty są osobno pobierane dla route dlatego czekam aż będą przekazane
    if (this.points) {
      this.showRoute();
    }
  }

  private showRoute() {
    this.onRouteEventDetailUpdate.emit(this.route);

    this.$routeService.pointUpdateRequired.subscribe(routePoint => {
      if (!this.route || this.route.Id != routePoint.RouteEventId)
        return;

      this.route.Points.push(routePoint);
      this.onRouteEventDetailUpdate.emit(this.route);
    });
  }

  /**
   * Data model is lacking of additional info, so they are calculated here
   */
  private calculateDetails(route: RouteEvent) {

    if (!route.St || !route.En) {
      this.Duration = undefined;
    } else {

      // Duration
      // Calculate time
      const startTime = new Date(route.St).getTime();
      const endTime = new Date(route.En).getTime();
      const duration = Math.floor((endTime - startTime) / 1000);
      this.Duration = duration;
    }
  }
}

